import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Section } from "../Section";
import { Button } from "@inceptionbg/ui-components";
import { InfoBox } from "../../Elements/Alert/InfoBox";
import {
  ApprovalConsentCheckboxes,
  IApprovalConsents,
  useApprovalConsents,
} from "../ApprovalConsent/ApprovalConsentCheckboxes";

interface Props {
  sectionTitle: string;
  infoBoxTitle: string;
  infoBoxDesc: string;
  onSubmit: (consents?: IApprovalConsents) => void;
  disableSubmit?: boolean;
  buttonLabel?: string;
  showApprovalConsents?: boolean;
  authorityConsentFromBackend?: boolean | null;
  children: ReactNode;
}

export const CustomRequestSection: FC<Props> = ({
  sectionTitle,
  infoBoxTitle,
  infoBoxDesc,
  onSubmit,
  disableSubmit,
  buttonLabel,
  showApprovalConsents,
  authorityConsentFromBackend,
  children,
}) => {
  const { t } = useTranslation();
  const { consents, setConsents } = useApprovalConsents(
    authorityConsentFromBackend
  );

  return (
    <Section id="basic" title={sectionTitle}>
      <InfoBox title={infoBoxTitle} desc={infoBoxDesc} className="mb-4" light />
      {children}
      {showApprovalConsents && (
        <ApprovalConsentCheckboxes consents={consents} onChange={setConsents} />
      )}
      <div className="flex center mt-3">
        <Button
          label={buttonLabel || t("SubmitRequest")}
          primary
          onClick={() => onSubmit(showApprovalConsents ? consents : undefined)}
          disabled={!!disableSubmit}
        />
      </div>
    </Section>
  );
};
